// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"527d9774","455":"a5e95492"}[chunkId] + ".chunk.js";
};